import React from 'react'

const CheckoutSectionHeader = ({ label }) => (
    <h4 className="headline headline-sm">{label}</h4>
)

export default CheckoutSectionHeader